<!-- main sidebar -->
<aside id="op-primary-sidebar" emSidebar isPrimary="true" top="48px" [mode]="mode" [position]="position">
  @if (showLanguageToggle || showMenuFilter) {
    <div class="em-sidebar-section">
      @if (showLanguageToggle) {
        <div [ngClass]="{ 'uk-margin-small-bottom': showMenuFilter }">
          <op-language-selector
            class="uk-margin-small-bottom"
            [languages]="languages"
            [current]="currentLanguage"
            (currentChange)="languageChange($event)" />
        </div>
      }
      @if (showMenuFilter) {
        <op-filter-menu [menu]="sections"></op-filter-menu>
      }
    </div>
  }
  @if (showChecklist) {
    <div class="em-sidebar-section">
      <op-sidebar-checklist [total]="total" [progress]="progress"
      [title]="checklistTitle" [desc]="checklistDesc" [link]="checklistLink"></op-sidebar-checklist>
    </div>
  }
  @if (showDivider) {
    <hr class="em-sidebar-divider" />
  }
  <div overlay-scrollbars [options]="_overlayScrollOptions" class="uk-flex-1">
    <op-main-menu [sections]="sections" [menuAccordionMode]="menuAccordionMode"
    [menuFixedFirstLevel]="menuFixedFirstLevel"></op-main-menu>
  </div>
</aside>
